export const dataAccountId = {
  type: 'string',
  minLength: 1,
};
